@if (form) {
  <div [formGroup]="form">
    <div class="cord-label">
      <h3 class="label">{{ 'SELECT_GROUPS' | translate }}</h3>
    </div>
    <app-auto-complete-list-group-roster
      [form]="form"
      [controlName]="'groupSelect'"
      [defaultMessageContent]="'ADD_GROUPS_TO_GROUP'"
      [shouldShowDefaultMessage]="false"
      (itemClicked)="onRosterClick($event)"
      [customListClass]="'list-group-preview'"
    ></app-auto-complete-list-group-roster>
    @if (form.controls.groupSelect.value && totalMembersCount > 0) {
      <div class="list-group-count">
        {{ 'SELECTED_STUDENTS_DUPLICATES_INCLUDED' | translate }}: <span class="counter">{{totalMembersCount}}</span>
      </div>
    }
    <div [hidden]="form.controls.groupSelect.value" class="empty-list-message" role="status" aria-live="polite">
      {{'ADD_GROUPS_TO_GROUP' | translate }}
    </div>
  </div>
}
